import React, {Component, Fragment} from 'react';
import {Col, ListGroupItem, Row} from 'reactstrap';
import {connect} from 'react-redux';
import NewTrainingTemplate from 'training/components/NewTrainingTemplate';
import {loadTrainingTemplates, selectTrainingTemplate, setSearchText} from 'training/actions';
import Loading from 'apa/components/Loading';
import autobind from 'autobind-decorator';
import {TrainingDetails} from 'training/components/TrainingTemplateDetails';

@connect(
    state => ({
        searchText: state.training.searchText
    }),
    {
        search: setSearchText
    }
)
class TrainingControls extends Component {
    render() {
        return (
            <div className="mt-3 row form-group">
                <div className="col-sm-3">
                    <div className="input-group">
                        <input sm="2" placeholder="Suche" type="text" className="form-control" value={this.props.searchText}
                               onChange={(e) => this.props.search(e.target.value)}
                        />
                        <div className="input-group-append">
                            <button type="button" className="btn btn-secondary"
                            onClick={()=>this.props.search('')}>Zurücksetzen</button>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6">
                    <NewTrainingTemplate />
                </div>
            </div>
        )
    }
}

@connect(
    state => ({
        active: state.training.selectedTrainingTemplate,
        searchText: state.training.searchText
    }),
    {
        select: selectTrainingTemplate
    }
)
class TrainingNav extends Component {

    @autobind
    select() {
        const {training, active} = this.props;
        if(active && training.id === active.id) {
            this.props.select(null)
        } else {
            this.props.select(null)
            this.props.select(training)
        }
    }

    render() {
        const {training, active} = this.props;
        const isActive = active === training;
        return <ListGroupItem
            active={isActive}
            onClick={this.select}
            className='btn btn-link text-left'
        >
            {training.name}
        </ListGroupItem>
    }
}


@connect(
    state => ({
        isLoading: state.training.isLoading,
        trainingTemplateList: state.training.trainingTemplateList,
        selectTrainingTemplate: state.training.selectedTrainingTemplate
    }),
    {
        load: loadTrainingTemplates
    }
)
export default class TrainingList extends Component {

    componentDidMount() {
        this.props.load()
    }

    render() {
        const {isLoading, trainingTemplateList} = this.props;
        if(isLoading)
            return <Loading />
        return <Fragment>
            <TrainingControls/>
            <Row>
                <Col sm={2}>
                    {
                        trainingTemplateList.map((training, idx) => (
                            <TrainingNav key={`training_nav_${idx}`} training={training} count={idx}/>))
                    }
                </Col>
                <Col>
                    <TrainingDetails/>
                </Col>
            </Row>
        </Fragment>
    }
}
